import { SVGProps, memo } from "react";

const AccountsCreatedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width || "33"} height={props.height || "32"} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon">
        <path id="Vector" d="M6.04163 17C6.04163 10.928 10.9696 6 17.0416 6C23.1136 6 28.0416 10.928 28.0416 17C28.0416 23.072 23.1136 28 17.0416 28C10.9696 28 6.04163 23.072 6.04163 17Z" stroke={props.stroke || "#0810FF"} strokeWidth={props.strokeWidth || "2"}/>
        <path id="Vector 678" d="M12.0416 16.7059L16.5871 21L22.0416 13" stroke={props.stroke || "#0810FF"} strokeWidth={props.strokeWidth || "2"} strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>

  );
};

export default memo(AccountsCreatedIcon);
